// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__116lf","buttons":"PendingPaymentAlert_buttons__Qf5U1"};